import script from "./imContactInfoTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./imContactInfoTemp.vue?vue&type=script&setup=true&lang=js"

import "./imContactInfoTemp.vue?vue&type=style&index=0&id=42fdf891&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fdf891"]])

export default __exports__